import React from 'react'
import Layout from '../components/layout'
import Billboard from '../components/Billboard'
import Seo from '../components/seo'
import CorporateMailingAddress from "../components/CorporateMailingAddress";
import {PreAssessmentForm} from "../components/pages/pre-assessment/pre-assessment-form";


const PreAssessmentPage = ({ data }) => {

  return (
    <Layout showContact={false}>
        <Seo
            title="Pre-Assessment"
            description="Fantastic Support made us the world leader in AWS Cloud Services. Contact Sales or Support any time night or day, we are here for you. Find out more today."
        />

        <Billboard className="Billboard--contact">
            <PreAssessmentForm/>
        </Billboard>

        <section className="sectionCities">
            <CorporateMailingAddress/>
        </section>
    </Layout>
  )
}

export default PreAssessmentPage
